import { doc, getDoc, getFirestore } from 'firebase/firestore'
import { useLoginWithAnotherRole, useOldUserLogin } from 'domains/Session/hooks'

import { COLLECTIONS } from '__constants__'
import { useCreateUser } from 'domains/User/hooks'

const useSignInWithProviderCredentials = () => {
  const oldUserLogin = useOldUserLogin()
  const createUser = useCreateUser()
  const loginWithAnotherRole = useLoginWithAnotherRole()
  const signInWithProviderCredentials = async (
    userAuthSnapshot,
    appleAuthData
  ) => {
    try {
      const firestore = getFirestore()

      const { uid, email, displayName } = userAuthSnapshot?.user || {}

      let isOldUser = false
      if (email) {
        isOldUser = await oldUserLogin({ email })
      }

      // Check if user document already exists to avoid overwriting existing data
      const userDocReference = doc(firestore, COLLECTIONS.USERS, uid)
      let userSnapshot = await getDoc(userDocReference)
      const userExists = userSnapshot.exists()
      if (!isOldUser) {
        if (!userExists) {
          const [firstName, lastName] = displayName?.split(' ') || []

          await createUser(
            uid,
            {
              ...userAuthSnapshot?.user,
              _id: uid,
              firstName,
              lastName
            },
            appleAuthData
          )

          // re-fetch after creation
          userSnapshot = await getDoc(userDocReference)
        }
      } else {
        if (userAuthSnapshot?.user?.email && userAuthSnapshot?.user?.uid) {
          await loginWithAnotherRole({ uid, email })
          // re-fetch after potential backend-side doc creation/update
          userSnapshot = await getDoc(userDocReference)
        }
      }

      const userData = userSnapshot.data() || {}

      return {
        user: { ...userData, id: uid, userID: uid },
        accountCreated: false
      }
    } catch (e) {
      throw new Error(e)
    }
  }

  return signInWithProviderCredentials
}

export default useSignInWithProviderCredentials
